import { render } from "./Auctionrules.vue?vue&type=template&id=227c4dec&scoped=true"
import script from "./Auctionrules.vue?vue&type=script&lang=js"
export * from "./Auctionrules.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227c4dec"]])

export default __exports__